import { ColorScheme } from '@opendoor/bricks/system/theme';
import { IconName, IconSize } from '@opendoor/bricks/core/Icon/Icon';

type BadgeOptionalAttributes = {
  color?: ColorScheme;
  size?: IconSize;
  viewBox?: string;
  backgroundColor?: ColorScheme;
  fontColor?: ColorScheme;
};

type BadgeIconOnlyProps = BadgeOptionalAttributes & {
  icon: IconName;
  title?: string;
};

type BadgeTitleProps = BadgeOptionalAttributes & {
  title: string;
  icon?: IconName;
};

type BadgeInfoProps = BadgeTitleProps | BadgeIconOnlyProps;

export const listingStatus = {
  open: 'open',
  selfTour: 'self-tour',
  popular: 'popular',
  earlyAccess: 'early_access',
  highDemand: 'high_demand',
  newConstruction: 'new_construction',
  '60%': '60%',
  '360': '360',
  geo: 'geo',
  pending: 'pending',
  sold: 'sold',
  offMarket: 'off_market',
  opendoor: 'opendoor',
  homebuilder: 'homebuilder',
} as const;

type Keys = keyof typeof listingStatus;
export type ListingStatus = typeof listingStatus[Keys];

export const badgeData: { [key in ListingStatus]: BadgeInfoProps } = {
  open: {
    icon: 'open',
  },
  'self-tour': {
    title: 'Self-Tour',
    icon: 'logo',
    size: 12,
    viewBox: '0 0 12 12',
  },
  popular: {
    title: 'Popular',
    icon: 'popular',
    size: 12,
    viewBox: '0 0 12 12',
  },
  early_access: {
    title: 'Early Access',
    icon: 'early-access',
    size: 12,
    viewBox: '0 0 12 8',
  },
  high_demand: {
    title: 'High Demand',
    icon: 'popular',
    size: 12,
    viewBox: '0 0 12 8',
  },
  new_construction: {
    title: 'New Construction',
    icon: 'new-construction',
    size: 12,
    viewBox: '0 0 12 12',
  },
  '360': {
    title: '360°',
    icon: '360',
    backgroundColor: 'neutrals100',
    color: 'neutrals0',
    fontColor: 'neutrals0',
  },
  '60%': {
    title: '60% Complete',
    icon: 'progress-bar',
    size: 12,
    viewBox: '0 0 12 12',
  },
  geo: {
    title: '4 Privet Drive',
    icon: 'geo',
    size: 12,
  },
  pending: {
    title: 'Pending',
  },
  sold: {
    title: 'Sold',
  },
  off_market: {
    title: 'Off Market',
  },
  opendoor: {
    title: 'Opendoor',
    icon: 'logo',
    size: 12,
    viewBox: '0 0 12 12',
  },
  homebuilder: {
    title: 'New Construction',
    icon: 'new-construction',
    size: 12,
    viewBox: '0 0 12 12',
  },
};
